<template>
  <div>
    <div class="is-hidden-x">
      <div class="map-labels desktop-label">
        <div class="label-item available" v-if="labels.available">
          <span></span>
          <!-- change back to available at clients request -->
          <p>Available</p>
        </div>
        <div class="label-item model" v-if="labels.available">
          <span></span>
          <p>Model</p>
        </div>
        <div class="label-item sold" v-if="labels.sold">
          <span></span>
          <p>Sold</p>
        </div>
        <div class="label-item future-release" v-if="labels.future">
          <span></span>
          <p>Future</p>
        </div>
        <div class="label-item spec" v-if="labels.spec">
          <span></span>
          <!-- change back to spec at clients request -->
          <p>Inventory</p>
        </div>
        <div class="label-item spec" v-if="labels.favorites">
          <span></span>
          <p>Favorites</p>
        </div>
        <div class="label-item lotsize-45" v-if="labels.lotsize">
          <span></span>
          <p>45'</p>
        </div>
        <div class="label-item lotsize-50" v-if="labels.lotsize">
          <span></span>
          <p>50'</p>
        </div>
        <div class="label-item lotsize-60" v-if="labels.lotsize">
          <span></span>
          <p>60'</p>
        </div>
        <div class="label-item lotsize-70" v-if="labels.lotsize">
          <span></span>
          <p>70'</p>
        </div>
      </div>
    </div>

    <div class="map-labels mobile-label-header">
      <div class="label-item available" v-if="labels.available">
        <span></span>
        <p>Available</p>
      </div>
      <div class="label-item model" v-if="labels.available">
        <span></span>
        <p>Model</p>
      </div>
      <div class="label-item sold" v-if="labels.sold">
        <span></span>
        <p>Sold</p>
      </div>
      <div class="label-item future-release" v-if="labels.future">
        <span></span>
        <p>Future</p>
      </div>
      <div class="label-item spec" v-if="labels.spec">
        <span></span>
        <p>Move-in Ready</p>
      </div>
      <div class="label-item spec" v-if="labels.favorites">
        <span></span>
        <p>Favorites</p>
      </div>
      <div class="label-item lotsize-45" v-if="labels.lotsize">
        <span></span>
        <p>45'</p>
      </div>
      <div class="label-item lotsize-50" v-if="labels.lotsize">
        <span></span>
        <p>50'</p>
      </div>
      <div class="label-item lotsize-60" v-if="labels.lotsize">
        <span></span>
        <p>60'</p>
      </div>
      <div class="label-item lotsize-70" v-if="labels.lotsize">
        <span></span>
        <p>70'</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app-community-map",
  props: {
    labels: {
      type: Object,
      default() {
        return {
          available: true,
          sold: true,
          model: true,
          future: true,
          spec: true,
          favorites: false,
          lotsize: false
        };
      }
    }
  },
  mounted() {
    // console.log(this.labels);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/journey/MapLabel.vue